/* Custom JS - Collection 'View' and 'Model' features */
document.addEventListener('DOMContentLoaded', () => {
    initCollectionViewModelEvents();
});

window.toggleCollectionModel = function() {
            var collectionModelContainer = document.querySelector(".collection-toolbar-model-container");
            if(collectionModelContainer != null) {
                var collectionModelButtonValue = collectionModelContainer.querySelector(".collection-toolbar__button.is-active").value;
                if(collectionModelButtonValue == "model-on") {
                    var collectionProductRegularImages = document.querySelectorAll(".collection-container-v2 .product-list .pcard-v2 .pcard-v2-image-regular");
                    //Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.add("d-none"));
                    Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.remove("pcard-v2__image--primary"));
                    Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.add("pcard-v2__image--secondary"));
                    
                    var collectionProductModelImages = document.querySelectorAll(".collection-container-v2 .product-list .pcard-v2 .pcard-v2-image-model");
                    //Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.remove("d-none"));
                    Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.remove("pcard-v2__image--secondary"));
                    Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.add("pcard-v2__image--primary"));
                }
                else {
                    var collectionProductModelImages = document.querySelectorAll(".collection-container-v2 .product-list .pcard-v2 .pcard-v2-image-model");
                    //Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.add("d-none"));
                    Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.remove("pcard-v2__image--primary"));
                    Array.from(collectionProductModelImages).forEach((collectionProductModelImage) => collectionProductModelImage.classList.add("pcard-v2__image--secondary"));

                    var collectionProductRegularImages = document.querySelectorAll(".collection-container-v2 .product-list .pcard-v2 .pcard-v2-image-regular");
                    //Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.remove("d-none"));
                    Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.remove("pcard-v2__image--secondary"));
                    Array.from(collectionProductRegularImages).forEach((collectionProductRegularImage) => collectionProductRegularImage.classList.add("pcard-v2__image--primary"));
                }
                const modelAttributeProperty = `products_desktop_view_model`;
                fetch(`${Shopify.routes.root}cart/update.js`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                    attributes: {
                        [modelAttributeProperty]: collectionModelButtonValue
                    }
                    }),
                    keepalive: true
                });
            }
};

window.initCollectionViewModelEvents = function() {
    var collectionViewContainer = document.querySelector(".collection-toolbar-view-container");
    if(collectionViewContainer != null) {
        collectionViewContainer.addEventListener("click", function(event) {
            if(event.target.type == "button")
                return;

            var collectionViewButton = collectionViewContainer.querySelector(".collection-toolbar__button.is-active");
                            
            if(collectionViewButton != null) {
                if (collectionViewButton.nextElementSibling) {
                    collectionViewButton.nextElementSibling.classList.add('pointer-events-on');
                    collectionViewButton.nextElementSibling.click();
                    collectionViewButton.nextElementSibling.classList.remove('pointer-events-on');
                }
                else {
                    var collectionViewButtonFirst = collectionViewContainer.querySelector(".collection-toolbar__button");
                    if(collectionViewButtonFirst != null) {
                        collectionViewButtonFirst.classList.add('pointer-events-on');
                        collectionViewButtonFirst.click();
                        collectionViewButtonFirst.classList.remove('pointer-events-on');
                    }
                }
            }
        });
   }

    var collectionModelContainer = document.querySelector(".collection-toolbar-model-container");
    if(collectionModelContainer != null) {
      collectionModelContainer.addEventListener("click", function(event) {
        if(event.target.type == "button")
            return;

        var collectionModelButton = collectionModelContainer.querySelector(".collection-toolbar__button.is-active");

        if(collectionModelButton != null) {
          if (collectionModelButton.nextElementSibling) {
              collectionModelButton.nextElementSibling.classList.add('pointer-events-on');
              collectionModelButton.nextElementSibling.click();
              collectionModelButton.nextElementSibling.classList.remove('pointer-events-on');
          }
          else {
            var collectionModelButtonFirst = collectionModelContainer.querySelector(".collection-toolbar__button");
            if(collectionModelButtonFirst != null) {
              collectionModelButtonFirst.classList.add('pointer-events-on');
              collectionModelButtonFirst.click();
              collectionModelButtonFirst.classList.remove('pointer-events-on');
            }
          }
        }
      });

      var collectionModelButtonList = collectionModelContainer.querySelectorAll(".collection-toolbar__button");
      collectionModelButtonList.forEach(modelButtonItem => {
        modelButtonItem.addEventListener("click", function(event) { 
            var eventTarget = event.target;
            Array.from(collectionModelButtonList).forEach((modelButtonItem1) => modelButtonItem1.classList.toggle("is-active", modelButtonItem1 === eventTarget));
            toggleCollectionModel();
        });
      });
    }
};